<template>
  <div>
    <div>
      <form
        v-if="step === 3"
        class="pt-2 pb-4 d-flex flex-wrap"
        @keypress.enter="$event.preventDefault()"
      >
        <div class="d-flex py-2 px-3" style="margin-left: -0.8rem">
          <span class="material-icons md-36 font-31" @click="step = 2"
            >keyboard_arrow_left</span
          >
        </div>

        <div class="container d-flex flex-column" style="height: 80vh">
          <div class="mt-4">
            <h2 class="font-weight-normal">
              {{ $t("message.accountDetails") }}
            </h2>

            <div class="mt-3">
              <label class="required" for="Name">{{
                $t("message.fullName")
              }}</label>
              <input
                id="Name"
                v-model="fullName"
                v-validate="'required|min:2'"
                :placeholder="isRolldStore() && $t('message.firstName')"
                class="form-control"
                name="name"
                type="text"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("name") | inputNameLocale("name") }}
              </div>
            </div>

            <div class="mt-3">
              <label class="required" for="EmailAddress">{{
                $t("message.email")
              }}</label>
              <input
                id="EmailAddress"
                v-model="detailModel.Email"
                v-validate="'required|email'"
                :placeholder="isRolldStore() && $t('message.email')"
                class="form-control"
                name="email"
                type="text"
                :readonly="emailDisabled"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("email") | inputNameLocale("email") }}
              </div>
            </div>

            <div class="mt-3">
              <label for="phoneNumber">{{ $t("message.mobileNumber") }}</label>
              <input
                id="phoneNumber"
                v-model="detailModel.Phone"
                v-validate="{
                  required: true,
                  min: 8,
                }"
                :disabled="detailModel.Phone"
                :placeholder="
                  isRolldStore() ? $t('message.phoneNumber') : '04XX XXX XXX'
                "
                class="form-control"
                name="phoneNumber"
                type="text"
              />
            </div>
          </div>

          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>

          <div class="w-100 flex-shrink-0">
            <button
              :disabled="loading"
              type="button"
              :style="desktopStyles.btn"
              class="btn btn-lg btn-sign-in btn-block shadow btn-dark d-flex justify-content-center align-items-center fs-1 fw-600"
              @click="createCustomerAndStartOrdering"
            >
              {{ $t("message.saveChanges") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
        </div>
      </form>
      <form
        v-else-if="step === 2"
        class="pt-2 pb-4 d-flex flex-wrap"
        @keypress.enter="$event.preventDefault()"
      >
        <div class="d-flex py-2 px-3 mb-4" style="margin-left: -0.8rem">
          <span class="material-icons md-36 font-31" @click="step = 1"
            >keyboard_arrow_left</span
          >

          <span class="ml-2 mt-1 font-weight-bold">
            {{ $t("message.verification") }}
          </span>
        </div>

        <div class="container my-4 d-flex flex-column align-items-center">
          <h2 class="font-weight-normal mb-2">
            {{ $t("message.verifyNumber") }}
          </h2>

          <div class="text-center">
            <p class="pt-4 font-weight-light">
              {{ $t("message.otpSent") }} {{ lastFourDigits }}
            </p>

            <p class="pt-2 font-weight-light">
              {{ $t("message.enterOtpHere") }}
            </p>
          </div>
        </div>

        <div
          class="form-group d-flex flex-wrap justify-content-center align-items-center"
        >
          <OtpInput
            ref="otpInput"
            :is-input-num="true"
            :num-inputs="6"
            :should-auto-focus="true"
            autocomplete="one-time-code"
            input-classes="otp-input"
            separator=""
            @on-complete="verifyOtpAndCheckout"
          />

          <div class="w-75 mt-3">
            <button
              :disabled="loading"
              :style="desktopStyles.btn"
              class="btn btn-lg btn-sign-in btn-block shadow btn-dark d-flex justify-content-center align-items-center fs-1 fw-600"
              @click="verifyOtpAndCheckout"
            >
              {{ $t("message.verifyCode") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
          <div
            class="w-85 mt-4 d-flex align-items-center justify-content-center"
          >
            <span>{{ $t("message.smsResendDescription") }}</span>
            <button
              :disabled="!enableResendBtn || loading"
              :style="desktopStyles.LinkColorTxt"
              class="btn btn-link pl-1 resend-btn"
              type="button"
              @click="resendSms"
            >
              {{ $t("message.smsResendButton") }}
              <span v-show="!enableResendBtn && !loading"
                >({{ resendWait }})</span
              >
            </button>
          </div>

          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </div>
      </form>

      <!--     step one form to enter mobile number     -->
      <form
        v-else
        class="pt-2 pb-4 d-flex flex-wrap"
        @keypress.enter="$event.preventDefault()"
      >
        <div class="d-flex py-2 px-3 mb-4" style="margin-left: -0.8rem">
          <span
            class="material-icons md-36 font-31"
            @click="$emit('closeMobileOtpModal')"
            >keyboard_arrow_left</span
          >

          <span class="ml-2 mt-1 font-weight-bold">
            {{ $t("message.verificationHeader") }}
          </span>
        </div>

        <div class="container my-4 d-flex flex-column align-items-center">
          <img alt="otp" src="../../assets/images/otp.png" />
          <h2 class="font-weight-normal mb-2 mt-2">
            {{ $t("message.verifyNumber") }}
          </h2>
          <div class="text-center">
            <p class="pt-4">{{ $t("message.verificationDescription") }}</p>
          </div>

          <div class="form-group w-75 my-4">
            <div class="d-flex">
              <div>
                <VueCountryCode
                  :preferredCountries="['au', 'us', 'gb']"
                  class="form-control country-input"
                  @onSelect="selectCountryCode"
                />
              </div>

              <div class="flex-grow-1">
                <div class="d-flex">
                  <p
                    class="form-control country-input mobile-input country-code d-flex align-items-center justify-content-center bg-white"
                  >
                    {{ countryCode }}
                  </p>
                  <input
                    id="mobile"
                    v-model="mobileNumber"
                    v-validate="{
                      required: true,
                      min: 6,
                    }"
                    class="form-control mobile-input flex-grow-1 pl-0"
                    name="mobile"
                    placeholder="mobile number"
                    style="border-left: 0; margin-left: -5px"
                    type="tel"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="w-75 d-flex justify-content-between">
            <button
              :disabled="loading"
              :style="desktopStyles.btn"
              type="button"
              class="btn btn-dark btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              @click="sendCheckoutVerificationOtp"
            >
              {{ $t("message.sendVerificationCodeBtn") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div class="my-4 text-center">
            <span class="font-weight-bold" style="font-size: 12px">
              {{ $t("message.mobileTermsAndConditions") }}
            </span>
          </div>

          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </div>
      </form>
    </div>
    <poweredby />
  </div>
</template>

<script>
import VueCountryCode from "vue-country-code";
import OtpInput from "@bachdgvn/vue-otp-input";
import shared from "../../sharedscripts/shop/Checkout/Checkout.js";
import { mapActions, mapGetters } from "vuex";
import poweredby from "./poweredby";
import { debounce } from "lodash";
import { UpdateCustomer } from "../../api/services/userService";
import { auth } from "../../server";
import firebase from "firebase/compat/app";
export default {
  name: "checkoutOtp",
  components: {
    VueCountryCode,
    OtpInput,
    poweredby,
  },
  props: {
    paymentMethod: {
      type: Number,
      default: 1,
      required: false,
    },
  },
  data() {
    return {
      step: 1,
      error: "",
      loading: false,
      resendWait: 30, //seconds
      countryCode: "",
      smsTimer: null,
      appVerifier: "",
      code: "",
      userSearchDebounce: null,
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
      },
      newUser: true,
    };
  },
  beforeDestroy() {
    clearInterval(this.smsTimer);
  },
  created() {
    this.initReCaptcha();
  },
  mounted() {
    this.userSearchDebounce = debounce(this.checkEmailExistance, 200);
    this.userSearchDebounce();
  },
  watch: {
    dbuser(newValue) {
      if (newValue && newValue.Email) {
        this.newUser = false;
        this.detailModel.Email = newValue.Email;
      }
      if (newValue && newValue.FirstName) {
        this.detailModel.FirstName = newValue.FirstName;
      }
      if (newValue && newValue.LastName) {
        this.detailModel.LastName = newValue.LastName;
      }
    },
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "user", "dbuser"]),
    emailDisabled() {
      if (auth.currentUser && auth.currentUser.email) {
        return true;
      }
      return false;
    },
    mobileNumber: {
      get() {
        const mobile = this.detailModel.Phone;
        if (!mobile) return "";
        if (mobile.startsWith("0")) {
          return mobile.slice(1);
        }
        return mobile;
      },
      set(val) {
        this.detailModel.Phone = val;
      },
    },

    // returns the last 4 digits of user mobile number
    lastFourDigits() {
      const mobile = this.detailModel.Phone;
      if (!mobile) return "";
      if (mobile <= 4) return mobile;
      return mobile.slice(-4);
    },
    fullName: {
      get() {
        if (!this.detailModel.LastName || !this.detailModel.LastName.length) {
          return this.detailModel.FirstName;
        }
        return this.detailModel.FirstName + " " + this.detailModel.LastName;
      },
      set(val) {
        if (!val) return;
        let names = val.split(" ");

        this.detailModel.FirstName = names[0];
        this.detailModel.LastName = names.slice(1, names.length + 1).join(" ");
      },
    },
  },
  methods: {
    ...mapActions([
      "logout",
      "authenticateUser",
      "setPhoneNumber",
      "signUserInPhone",
    ]),
    ...shared.methods,
    async verifyOtpAndCheckout(code) {
      try {
        this.code = code && code.length ? code : this.code;
        await this.verifyOtp(code);
        this.setPhoneNumber(this.detailModel.Phone);
      } catch (e) {
        this.error = e.message || "Something went wrong. Please try again";
      }
    },
    async createCustomerAndStartOrdering() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        await this.updateCustomerBackend();
      }
    },
    startOrdering() {
      this.$emit("checkout");
    },
    onEmailChange() {
      this.userSearchDebounce();
    },
    async updateCustomerBackend() {
      const that = this;
      that.loading = true;
      try {
        const mobile = this.formatMobile(that.detailModel.Phone);
        let phoneNumber = mobile;
        if (mobile && mobile[0] != "+") {
          phoneNumber = that.countryCode + mobile;
        }
        const userInfo = {
          Email: that.detailModel.Email,
          PhoneNumber: phoneNumber,
          Mobile: phoneNumber,
          FirstName: that.detailModel.FirstName,
          LastName: that.detailModel.LastName,
          HQCompanyID: that.currentStoreDoc.HQCompanyID,
        };
        let user = auth.currentUser;

        await UpdateCustomer(user.uid, userInfo);
        that.startOrdering();
        that.loading = false;
      } catch (error) {
        that.error = error.message;
        that.loading = false;
      }
    },
    // login non branded store user
    async sendCheckoutVerificationOtp(e) {
      e.preventDefault();
      const that = this;
      try {
        that.loading = true;
        that.smsTimer = setInterval(() => {
          if (that.resendWait > 0) that.resendWait--;
        }, 1000);
        that.error = "";
        const mobile = this.formatMobile(that.detailModel.Phone);
        if (!mobile) {
          that.error = "Please enter a valid mobile number";
          return;
        }

        const phoneNumber = that.countryCode + mobile;
        if (!phoneNumber || !phoneNumber.length) {
          that.error = "Please enter a valid mobile number";
          return;
        }
        await this.sendUserOtp(phoneNumber);
        that.step = that.step === 1 ? 2 : 1;
      } catch (error) {
        switch (error.code) {
          case "auth/invalid-phone-number":
            that.error = "Invalid Phone Number Format !";
            break;

          default:
            that.error = error.message;
        }
      } finally {
        that.loading = false;
      }
    },
    // send OTP reusable function
    async sendUserOtp(phoneNumber) {
      try {
        const that = this;
        const appVerifier = that.appVerifier;
        const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(
          phoneNumber,
          appVerifier
        );
        that.verificationId = verificationId;
      } catch (e) {
        throw e;
      }
    },
    async verifyOtp(code) {
      const that = this;
      try {
        that.error = "";
        that.loading = true;
        if (code.length !== 6) {
          that.error = "Invalid OTP Format !";
          return;
        }

        const mobile = this.formatMobile(that.detailModel.Phone);
        const phoneNumber = that.countryCode + mobile;
        // const userExists = await this.checkPhoneExistence(phoneNumber);

        const payload = {
          verificationId: that.verificationId,
          verificationCode: code,
        };

        await that.signUserInPhone(payload);
        this.step = 3;
        that.detailModel.Phone = phoneNumber;
      } catch (error) {
        switch (error.code) {
          case "auth/invalid-verification-code":
            that.error = "Invalid OTP !";
            break;
          default:
            that.error =
              error.message || "An Error Occurred During Authentication";
        }
      } finally {
        that.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
